export const staticConfig = {
    envaccesscompany: (window as any).env.REACT_APP_ADMINISTER_ACCESS_COMPANY as string,
    envaccesscitizen: (window as any).env.REACT_APP_ADMINISTER_ACCESS_CITIZEN as string,
    apiBaseUrl: ((window as any).env.REACT_APP_USE_PROXY_MOCK as boolean)
        ? ((window as any).env.REACT_APP_PROXY_MOCK_API_URL as string)
        : ((window as any).env.REACT_APP_USER_API_URL as string),
    apiClientId: (window as any).env.REACT_APP_CLIENT_ID as string,
    authServerAuthorizeEndpoint: (window as any).env.REACT_APP_AUTHORIZE_ENDPOINT as string,
    authServerTokenEndpoint: (window as any).env.REACT_APP_TOKEN_ENDPOINT as string,
    authServerUserInfoEndpoint: (window as any).env.REACT_APP_USERINFO_ENDPOINT as string,
    authServerLogoutEndpoint: (window as any).env.REACT_APP_LOGOUT_ENDPOINT as string,
    authServerAuthorizeTestIdpEndpoint: (window as any).env.REACT_APP_AUTHORIZE_TESTIDP_ENDPOINT as string,
    authenticateUserTokenEndpoint: (window as any).env.REACT_APP_CLASSIC_AUTHENTICATE_USER_TOKEN as string,
    classicLogoutEndpoint: (window as any).env.REACT_APP_CLASSIC_LOGOUT_ENDPOINT as string,
    classicLogonEndpoint: (window as any).env.REACT_APP_CLASSIC_LOGON_ENDPOINT as string,
    classicMailboxLink: (window as any).env.REACT_APP_CLASSIC_MAILBOX as string,
    classicOverviewLink: (window as any).env.REACT_APP_CLASSIC_OVERVIEW as string,
    classicOverviewBaseLink: (window as any).env.REACT_APP_CLASSIC_BASE as string,
    consentBaseURL: (window as any).env.REACT_APP_BASE as string,
    isclassicunavailable: (window as any).env.REACT_APP_CLASSIC_UNAVAILABLE as boolean,
    classicUnavailableLogoutEndpoint: (window as any).env.REACT_APP_CLASSIC_UNAVAILABLE_LOGOUT_URL as string,
    temporaryTokenDebug: (window as any).env.REACT_APP_TEMPORARY_TOKEN_DEBUG as boolean,
    useNgdp: (window as any).env.REACT_APP_USE_NGDP as boolean,
    inactiveMinutesBeforeAutoLogOffPopupShown: (window as any).env
        .REACT_APP_INACTIVE_MINUTES_BEFORE_AUTO_LOGOFF_POPUP_SHOWN as number,
    minutesBeforeAutoLogOffAfterAutoLogOffPopupShown: (window as any).env
        .REACT_APP_MINUTES_BEFORE_AUTO_LOGOFF_AFTER_AUTO_LOGOFF_POPUP_SHOWN as number,
    useTestExpiryTime: (window as any).env.REACT_APP_REMINDER_EXPIRY_TIME_TEST as boolean,
    useProxyMock: (window as any).env.REACT_APP_USE_PROXY_MOCK as boolean,
    appBaseUrl: window.location.protocol + '//' + window.location.host + '/',
    appHost: window.location.host,
    auth: {
        scopes: ['openid'],
        anonymousRoutes: ['/verify/email', '/unverify/email', '/activate-password'],
    },
    validations: {
        messageTitleMaxLength: 100,
    },
    maxStatisticsDataDotsAmount: 50,
    defaultTitle: 'e-Boks',
    defaultUrl: '#root',
};
